<template>
  <div v-if="show">
    <span class="fs-3">Accounts Manager</span>
    <div class="container mt-3">
      <div class="d-flex gap-4">
        <div class="form-check">
          <input class="form-check-input" name="searchby" type="radio" value="char_id" v-model="this.bySearch" id="chk_char_id" />
          <label class="form-check-label capitalize" for="chk_char_id">
            By Character ID
          </label>
        </div>
        <div class="form-check">
          <input class="form-check-input" name="searchby" default type="radio" value="email" v-model="this.bySearch" id="chk_email" />
          <label class="form-check-label capitalize" for="chk_email">
            By Email or Account ID
          </label>
        </div>
      </div>
      <div class="input-group" v-if="bySearch=='char_id'">
        <div class="form-outline">
          <input type="number" id="form1" class="form-control" placeholder="Search" v-model="search"
            @change="getProfileByCharId()" />
        </div>
        <button type="button" class="btn btn-primary">
          <i class="fas fa-search"></i>
        </button>
      </div>
      
    </div>
    <DataTableMod v-if="bySearch=='email'" :headers="headers" :actions="actions" :api="getProfile" :fields="['email', '_id']"
      :trigger="trigger" :showSearch="true"/>
    <DataTable v-if="bySearch=='char_id'" :headers="headers" :actions="actions" :items="items" />
    <WcoinModal :data="wcoinData" v-if="wcoinData.show" :api="store.custom.apis[store.custom.countryCode]" />
    <ProfileCharactersModal :data="this.charData" v-if="this.charData.show"
      :api="store.custom.apis[store.custom.countryCode]" :server="store.custom.regionserver" />
    <ProfileEquipmentsModal :data="this.itemsData" v-if="this.itemsData.show" :api="store.custom.apis[store.custom.countryCode]
      "></ProfileEquipmentsModal>
    <ShowBind :data="this.bindData" v-if="this.bindData.show"></ShowBind>
    <SendRewards :data="this.rewardData" v-if="this.rewardData.show" :api="store.custom.apis[store.custom.countryCode]">
    </SendRewards>
  </div>
</template>

<script>
  // import DataTable2 from "data-table/src/components/DataTable2.vue";
  import DataTableMod from "../components/DataTable/DataTable-Mod.vue";
  import DataTable from "data-table/src/components/DataTable";
  import WcoinModal from "../components/WcoinModal";
  import store from "node-back-client/src/store";
  import ProfileCharactersModal from "../components/ProfileCharactersModal";
  import ProfileEquipmentsModal from "../components/ProfileEquipmentsModal";
  import ShowBind from "../components/ShowBind.vue";
  import SendRewards from "../components/Modals/SendRewards.vue";
  export default {
    name: "Account",
    data() {
      return {
        show: false,
        trigger: {},
        store: store,
        wcoinData: {
          show: false,
          entity: null,
        },
        profileTrans: {
          show: false,
          entity: null,
        },
        charData: {
          show: false,
          entity: null,
          data: {},
        },
        itemsData: {
          show: false,
          entity: null,
        },
        bindData: {
          show: false,
          entity: null,
        },
        rewardData: {
          show: false,
          entity: null,
        },
        headers: {
          // _id: "ID",
          accountId: "Account ID",
          email: "Email",
          binded: "Binded",
          cheaterType: "Cheater Type",
        },
        actions: [
          {
            classNames: "fas fa-link text-success",
            callback: this.binds,
          },
          {
            classNames: "fas fa-gift text-success",
            callback: this.sendRewards,
          },
          {
            classNames: "fa fa-coins text-warning",
            callback: this.history,
          },
          {
            classNames: "fa fa-trophy text-success",
            callback: this.edit,
          },
          {
            classNames: "fa-solid fa-users text-dark",
            callback: this.characters,
          },
          {
            classNames: "fa-solid fa-vault text-dark",
            callback: this.profileEquipments,
          },
          {
            classNames: "fa fa-trash text-danger",
            callback: this.remove,
          },

        ],
        byCharId: false,
        bySearch:"email",
        search: "",
        items: [],
      };
    },
    methods: {
      async getProfile() {
        if (this.byCharId) {
          return store.custom.apis[store.custom.countryCode].user.getProfiles();
        }
        return await store.custom.apis[
          store.custom.countryCode
        ].user.getProfiles(...arguments, store.custom.countryCode);
      },
      async getProfileByCharId() {
        this.items = [
          await store.custom.apis[
            store.custom.countryCode
          ].user.getProfilesByCharId(store.custom.regionserver, this.search, store.custom.countryCode),
        ];
      },
      async getProfileById() {
        this.items = [
          await store.custom.apis[
            store.custom.countryCode
          ].user.getProfilesById(store.custom.regionserver, this.search, store.custom.countryCode),
        ];
      },
      async binds(entity) {
        this.bindData.entity = entity;
        this.bindData.show = true;
      },
      characters(entity) {
        this.charData.entity = entity;
        this.charData.show = true;
        this.charData.isAdd = true;
      },
      profileEquipments(entity) {
        this.itemsData.entity = entity;
        this.itemsData.show = true;
        this.itemsData.isAdd = true;
      },
      history(entity) {
        this.wcoinData.entity = entity;
        this.wcoinData.show = true;
        this.wcoinData.isAdd = true;
      },
      transactions(entity) {
        this.profileTrans.entity = entity;
        this.profileTrans.show = true;
        this.profileTrans.isAdd = true;
      },
      edit(entity) {
        this.wcoinData.entity = entity;
        this.wcoinData.show = true;
        this.wcoinData.isAdd = false;
      },
      remove(entity) {
        console.log(entity, "Not available yet");
      },
      sendRewards(entity) {
        this.rewardData.entity = entity;
        this.rewardData.show = true;
      }
    },
    created() {
      store.custom.callbacks.account = () => {
        if (this.trigger.refresh != null) this.trigger.refresh();
      };
      store.custom.callbacks.init = () => {
        this.show = true;
      };

      if (store.custom.isInit) {
        this.show = true;
      }
    },
    unmounted() {
      delete store.custom.callbacks.account();
    },
    components: {
      WcoinModal,
      // DataTable2,
      DataTable,
      DataTableMod,
      ProfileCharactersModal,
      ProfileEquipmentsModal,
      ShowBind,
      SendRewards
    },
  };
</script>
